import * as React from 'react';
import { Tooltip } from "reactstrap";
import { PermissionEnum } from '../../models';
import PermContactCalendar from "@material-ui/icons/PermContactCalendar";
import DateRange from "@material-ui/icons/DateRange";
import AttachMoney from '@material-ui/icons/AttachMoney';
import Work from '@material-ui/icons/Work';
import Email from '@material-ui/icons/Email';
import Visibility from '@material-ui/icons/Visibility';
import Description from '@material-ui/icons/Description';
import SupervisorAccount from '@material-ui/icons/SupervisorAccount';
import AccountBox from '@material-ui/icons/AccountBox';
import Timeline from '@material-ui/icons/Timeline';
import Dashboard from '@material-ui/icons/Dashboard';
import Lock from '@material-ui/icons/Lock';
import Chat from '@material-ui/icons/Chat';
import { TK } from '../../store/translations/translationKeys';
import { useTranslations } from '../../store/translations/hooks';
import './PermissionBadge.scss';
import { Block, EventBusy, EventAvailable } from '@material-ui/icons';

const PermissionBadge: React.FC<{permission: PermissionEnum | 'Professional'}> = (props) => {

    const { permission } = props;

    const getProperties = (permission: PermissionEnum | 'Professional'): {
        colorClass: string,
        translationKey?: TK,
        AreaIcon?: React.ElementType,
        ActionIcon?: React.ElementType,
    } => {
        switch(permission){
            case PermissionEnum.Administrator: return {
                colorClass: 'permissionDark',
                translationKey: TK.permissionAdministratorDescription,
                AreaIcon: SupervisorAccount as React.ElementType,
            };
            case PermissionEnum.PricesAccess: return {
                colorClass: 'permissionWarning',
                translationKey: TK.permissionPricesAccessDescription,
                AreaIcon: AttachMoney as React.ElementType,
            };
	        case PermissionEnum.PricesManagement: return {
                colorClass: 'permissionWarning',
                translationKey: TK.permissionPricesManagementDescription,
                AreaIcon: Timeline as React.ElementType,
            };
	        case PermissionEnum.ProfessionalsManagement: return {
                colorClass: 'permissionInfo',
                translationKey: TK.permissionProfessionalsManagementDescription,
                AreaIcon: Work as React.ElementType,
            };
	        case PermissionEnum.ClientsAccess: return {
                colorClass: 'permissionPrimary',
                translationKey: TK.permissionClientsAccessDescription,
                AreaIcon: PermContactCalendar as React.ElementType,
                ActionIcon: Visibility as React.ElementType,
            };
	        case PermissionEnum.ClientsReports: return {
                colorClass: 'permissionPrimary',
                translationKey: TK.permissionClientsReportsDescription,
                AreaIcon: Description as React.ElementType,
            };
	        case PermissionEnum.ClientsManagement:  return {
                colorClass: 'permissionPrimary',
                translationKey: TK.permissionClientsManagementDescription,
                AreaIcon: PermContactCalendar as React.ElementType,
            };
	        case PermissionEnum.MyClientsManagement: return {
                colorClass: 'permissionPrimary',
                translationKey: TK.permissionMyClientsManagementDescription,
                AreaIcon: PermContactCalendar as React.ElementType,
                ActionIcon: Lock as React.ElementType,
            };
	        case PermissionEnum.AppointmentsAccess: return {
                colorClass: 'permissionSuccess',
                translationKey: TK.permissionAppointmentsAccessDescription,
                AreaIcon: DateRange as React.ElementType,
                ActionIcon: Visibility as React.ElementType,
            };
	        case PermissionEnum.AppointmentsManagement: return {
                colorClass: 'permissionSuccess',
                translationKey: TK.permissionAppointmentsManagementDescription,
                AreaIcon: DateRange as React.ElementType,
            };
	        case PermissionEnum.CampaignsManagement: return {
                colorClass: 'permissionDanger',
                translationKey: TK.permissionCampaignsManagementDescription,
                AreaIcon: Email as React.ElementType,
            };
	        case PermissionEnum.Analytics: return {
                colorClass: 'permissionDanger',
                translationKey: TK.permissionAnalyticsDescription,
                AreaIcon: Dashboard as React.ElementType,
            };
	        case PermissionEnum.ClientsChat: return {
                colorClass: 'permissionDanger',
                translationKey: TK.permissionClientsChatDescription,
                AreaIcon: Chat as React.ElementType,
            };
            case 'Professional': return {
                colorClass: 'permissionDark',
                translationKey: TK.permissionProfessionalDescription,
                AreaIcon: AccountBox as React.ElementType,
            };
	        case PermissionEnum.DoNotAllowSkipAvailability: return {
                colorClass: 'permissionWarning',
                translationKey: TK.permissionDoNotAllowSkipAvailabilityDescription,
                AreaIcon: Block as React.ElementType,
                ActionIcon: EventBusy as React.ElementType,
            };
	        case PermissionEnum.DoNotAllowToConfirmAppointments: return {
                colorClass: 'permissionWarning',
                translationKey: TK.permissionDoNotAllowToConfirmAppointmentsDescription,
                AreaIcon: Block as React.ElementType,
                ActionIcon: EventAvailable as React.ElementType,
            };
	        case PermissionEnum.DoNotShowPrices: return {
                colorClass: 'permissionWarning',
                translationKey: TK.permissionDoNotShowPricesDescription,
                AreaIcon: Block as React.ElementType,
                ActionIcon: AttachMoney as React.ElementType,
            };
	        case PermissionEnum.DoNotCreateOrEditAppointments: return {
                colorClass: 'permissionWarning',
                translationKey: TK.permissionDoNotCreateOrEditAppointmentsDescription,
                AreaIcon: Block as React.ElementType,
                ActionIcon: DateRange as React.ElementType,
            };
            default: return {
                colorClass: 'permissionLight',
            };
        }
    }

    const t = useTranslations();
    const [tooltipOpen, setTooltipOpen] = React.useState(false);

    const id = `permission${permission.toString()}`;

    const {
        colorClass,
        translationKey,
        AreaIcon,
        ActionIcon,
    } = getProperties(permission);

    return (
        <>
            <div className={`permissionBadge ${colorClass}`} id={id}>
                { AreaIcon && <AreaIcon className="badgeAreaIcon" /> }
                { ActionIcon && <ActionIcon className="badgeActionIcon" /> }
            </div>
            <Tooltip
                placement="bottom"
                isOpen={tooltipOpen}
                target={id} toggle={() => setTooltipOpen(!tooltipOpen)}
            >
                { translationKey && t(translationKey) }
            </Tooltip>
        </>
    );
}

export default PermissionBadge;